import { render, staticRenderFns } from "./ReportStudent.vue?vue&type=template&id=65a0a198&"
import script from "./ReportStudent.vue?vue&type=script&lang=js&"
export * from "./ReportStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports